import { Admin, CustomRoutes, Resource } from 'react-admin'
import { Route } from 'react-router-dom'
import { authProvider } from './authProvider'
import { ManageUsers } from './concepts/Account/views/ManageUsers'
import { PartnerProvider } from './concepts/Admin/providers/partnerProvider'
import AffiliateCreate from './concepts/Affiliates/views/AffiliateCreate'
import EarningsList from './concepts/Earnings/views/EarningsList'
import ForgotPassword from './concepts/Login/views/ForgotPassword'
import Login from './concepts/Login/views/Login'
import ResetPassword from './concepts/Login/views/ResetPassword'
import UpdatePassword from './concepts/Login/views/UpdatePassword'
import SalesProvider from './concepts/Sales/storage/SalesProvider'
import { SaleList } from './concepts/Sales/views/SaleList'
import { SaleShow } from './concepts/Sales/views/SaleShow'
import { dataProvider } from './dataProvider'
import usePartnerName from './layout/hooks/usePartnerName'
import Layout from './layout/Layout'
import { routesConfig } from './routesConfig'

import { Settings } from 'luxon'
import { darkTheme, lightTheme } from './theme'

Settings.defaultZone = 'America/Los_Angeles'

export const App = () => {
  const partnerName = usePartnerName()

  const getLabel = (pageTitle: string, partnerName?: string) => {
    return partnerName ? `${partnerName} / ${pageTitle}` : pageTitle
  }

  return (
    <SalesProvider>
      <PartnerProvider>
        <Admin
          title="Partners @ StackCommerce"
          dataProvider={dataProvider}
          authProvider={authProvider}
          layout={Layout}
          loginPage={Login}
          darkTheme={darkTheme}
          lightTheme={lightTheme}
          requireAuth
        >
          <Resource
            name="sales"
            list={SaleList}
            show={SaleShow}
            options={{ label: getLabel('Sales', partnerName) }}
            recordRepresentation={(record) => `/ ${record.name}`}
          />
          <Resource
            name="earnings/summary"
            list={EarningsList}
            options={{ label: getLabel('Earnings', partnerName) }}
          />
          <Resource
            name="account/manage-users"
            list={ManageUsers}
            options={{
              label: getLabel('Account / Manage Users', partnerName)
            }}
          />
          <CustomRoutes noLayout>
            <Route path="/affiliates/create" element={<AffiliateCreate />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route
              path="/reset-password"
              element={<ResetPassword intent="reset" />}
            />
            <Route
              path="/activate-account"
              element={<ResetPassword intent="activate" />}
            />
          </CustomRoutes>
          <CustomRoutes>
            <Route path="/update-password" element={<UpdatePassword />} />
            {routesConfig.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </CustomRoutes>
        </Admin>
      </PartnerProvider>
    </SalesProvider>
  )
}
